export const getCookie = (name: string) => {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (decodeURIComponent(cookieName) === name) {
        try {
          return JSON.parse(decodeURIComponent(cookieValue));
        } catch (e) {
          return decodeURIComponent(cookieValue);
        }
      }
    }
  
    return null;
  };
